export function handleShadowScrolling() {
  const { scrollLeft, offsetWidth, scrollWidth } = this.node
  const Parent = this.lookup('ScrollShadows')

  if (!Parent) {
    console.warn('ScrollShadowsChild must need a ScrollShadows as a parent')
    return
  }

  if (scrollLeft === 0 && offsetWidth === scrollWidth) {
    return Parent.update({
      ':after': { opacity: '0%' },
      ':before': { opacity: '0%' }
    })
  }

  if (scrollLeft + offsetWidth === scrollWidth) {
    return Parent.update({ ':after': { opacity: '0%' } })
  }
  Parent.update({ ':after': { opacity: '100%' } })

  if (scrollLeft === 0) {
    return Parent.update({ ':before': { opacity: '0%' } })
  }
  Parent.update({ ':before': { opacity: '100%' } })
}
